export enum WidgetTypes {
	QUICK_GLANCE = 'quick_glance',
	BUTTON_ICON = 'button_icon',
	OMNI_SEARCH_BUTTON_ICON = 'omni_search_button_icon',
	BUTTON_TEXT = 'button_text',
	BUTTON_HEADER = 'button_header',
	BUTTON_CONTENT_SWITCHER = 'button_content_switcher',
	BUTTON_ESSENTIAL_INFO = 'button_essential_info',
	BANNER = 'banner',
	MAIN_DETERMINANT = 'main_determinant',
	SUB_DETERMINANT_BADGE = 'sub_determinant_badge',
}
